import { render, staticRenderFns } from "./SmallPaymentMethodSelector.vue?vue&type=template&id=80debb2e&scoped=true"
import script from "./SmallPaymentMethodSelector.vue?vue&type=script&lang=js"
export * from "./SmallPaymentMethodSelector.vue?vue&type=script&lang=js"
import style0 from "./SmallPaymentMethodSelector.vue?vue&type=style&index=0&id=80debb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80debb2e",
  null
  
)

export default component.exports